import React from 'react';
import Header from './components/Header';
import PollForm from './components/PollForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <PollForm />
    </div>
  );
}

export default App;